import { CustomLink } from "@/components/Global/CustomLink";
import React from "react";
import styles from "./LoginNavigation.module.scss";
import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

export const LoginNavigation = ({
  href,
  label,
}: {
  href: string;
  label: string;
}) => {
  const { getIcon, getLabel } = useGlobalContext();
  return (
    <div className={styles["login-navigation"]}>
      <div className={styles["login-navigation-link"]}>
        <CustomLink href={href} target="_self">
          {label}
          <ReactSVG
            wrapper="svg"
            src={getIcon("arrowRight")}
            className={styles["arrow-icon"]}
            width={16}
            height={16}
            beforeInjection={(svg) => {
              svg.setAttribute("alt", "Arrow right Icon");
              svg.setAttribute("aria-label", "Arrow right Icon");
            }}
          />
        </CustomLink>
      </div>
      <span
        className={`${styles["login-navigation-headline"]} login-area-headline`}
      >
        {getLabel("login_form_headline")}
      </span>
    </div>
  );
};
